import { Portlet } from "@/components"
import { fullDatetime } from "@/utils/time"
import {
	Grid,
	TableContainer,
	Table,
	TableRow,
	TableHead,
	TableCell,
	TableBody,
	Typography,
	Chip
} from "@material-ui/core"
import React from "react"
import useStyles from "@/pages/Admin/ClientCatalog/ImportContacts/ImportContactsHistory/styles"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

import { ContactsImportType, ImportContactsHistoryType } from "@/protocols/clientCatalogImportProtocol"

interface ImportContactsHistoryProps {
	importContactsHistoryList: ImportContactsHistoryType[],
	setOpenImportContactsReportDialog: (value: boolean) => void,
	setSelectedImportContactsHistory: (value: ImportContactsHistoryType) => void,
}

const ImportContactsHistory = (props: ImportContactsHistoryProps) => {
	const { importContactsHistoryList, setSelectedImportContactsHistory, setOpenImportContactsReportDialog } = props

	const classes = useStyles()

	const statusToMaterialChips: Record<string, JSX.Element> = {
		finished: <Chip size="small" label="Importado" style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.green[200]), width: "120px" }} />,
		importing: <Chip size="small" label="Importando..." style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100]), width: "120px" }} />,
		error: <Chip size="small" label="Erro" style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.red[100]), width: "120px" }} />
	}

	const contactsImportTypeToImportTypeChip: Record<ContactsImportType, JSX.Element> = {
		text: <Chip
			size="small"
			label="Por texto"
			style={{ backgroundColor: colors.purple[100], width: "120px" }} />,
		file: <Chip
			size="small"
			label="Por arquivo"
			style={{ backgroundColor: colors.blue[100], width: "120px" }} />
	}

	const handleOpenImportContactsReportDialog = (importContactsHistory: ImportContactsHistoryType) => {
		setSelectedImportContactsHistory(importContactsHistory)
		setOpenImportContactsReportDialog(true)
	}

	const idTableCellWidth = "15%"

	return <Grid container xs={12}>
		<Portlet>
			{
				importContactsHistoryList?.length > 0 ? <TableContainer>
					<Table
						stickyHeader={true}
						size="small"
						style={{ borderRadius: "8px", tableLayout: "fixed" }}
					>
						<TableHead>
							<TableRow>
								<TableCell width={idTableCellWidth}>
									ID
								</TableCell>

								<TableCell>
									Data de Criação
								</TableCell>

								<TableCell>
									Tipo de importação
								</TableCell>

								<TableCell>
									Status
								</TableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{importContactsHistoryList?.map((importContactsHistory, index) => (
								<TableRow
									key={index}
									tabIndex={-1}
								>
									<TableCell>
										<Typography
											variant="body1"
											className={importContactsHistory?.status === "importing" ? undefined : classes.contactFilterItem}
											onClick={importContactsHistory?.status === "importing" ? undefined : () => handleOpenImportContactsReportDialog(importContactsHistory)}
										>
											{ `#${importContactsHistory?.id}` }
										</Typography>
									</TableCell>

									<TableCell
									>
										<Typography
											variant="body1"
										>
											{importContactsHistory?.createdAt && fullDatetime(new Date(importContactsHistory?.createdAt))}
										</Typography>
									</TableCell>

									<TableCell>
										{importContactsHistory?.importType && contactsImportTypeToImportTypeChip[importContactsHistory?.importType]}
									</TableCell>

									<TableCell
									>
										{importContactsHistory?.status && statusToMaterialChips[importContactsHistory?.status]}
									</TableCell>
								</TableRow>
							))}
						</TableBody>

					</Table>
				</TableContainer> : <Typography variant="body1" align="center">Você ainda não possui importações</Typography>
			}
		</Portlet>
	</Grid>
}

export default ImportContactsHistory
